<template>
  <form @submit.prevent="handleSubmit(item)">
    <b-row>
      <b-col>
        <b-row>
          <b-col sm="12">
            <div class="form-group">
              <label
                for="excm_title"
                class="form-control-label">{{$t('views.excmtag.title')}}:</label>
              <input
                id="excm_title"
                v-model="item.tag"
                :class="['form-control', isInvalid('name') ? 'is-invalid' : '']"
                type="text"
                required="true"
                placeholder=""
                @input="handleUpdateField('name', $event.target.value)">
              <div
                v-if="isInvalid('name')"
                class="invalid-feedback">{{ violations.name }}</div>
            </div>
          </b-col>
          <b-col sm="12">
            <b-form-group>
              <label>{{ $t('views.excmtag.consentTag') }}</label>
              <model-select id="consentTag" v-model="item.tagType" :options="tagTypeOptions" name="tagType" :placeholder="$t('views.excmtag.consentTag')"></model-select>
            </b-form-group>
          </b-col>
          <b-col sm="12" lg="4">
            <div class="form-group">
              <label for="color"
                     class="form-control-label">{{$t('views.exsbitems.form.color')}}</label><br>
              <el-color-picker v-model="item.color"></el-color-picker>
              <div
                v-if="isInvalid('color')"
                class="invalid-feedback">{{ violations.color }}</div>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <button type="submit" class="btn btn-primary">{{ $t('buttons.submit') }}</button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </form>
</template>

<script>
import { ModelSelect } from 'vue-search-select'

export default {
  components: {
    ModelSelect
  },
  data () {
    return {
      tagTypeOptions: [
        {
          text: this.$t('views.excmtag.tagOption.tagTypeOption1'),
          value: 1
        },
        {
          text: this.$t('views.excmtag.tagOption.tagTypeOption2'),
          value: 2
        },
        {
          text: this.$t('views.excmtag.tagOption.tagTypeOption3'),
          value: 3
        },
        {
          text: this.$t('views.excmtag.tagOption.tagTypeOption4'),
          value: 4
        },
        {
          text: this.$t('views.excmtag.tagOption.tagTypeOption5'),
          value: 5
        }
      ],
      tagType: 1
    }
  },
  props: {
    // item: {
    //   type: Object,
    //   required: true
    // },
    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    },

    itemsOptions: {
      type: Array,
      require: true
    }
  },

  computed: {
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    violations () {
      return this.errors || {}
    }
  },

  methods: {
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    }
  }
}
</script>
